import {
  RegistrationDocument,
  RegistrationLkmData,
  TSuggest,
} from 'feature/registration/types'

import { createEmptyAddress } from 'feature/registration/heplers/addressHelpers'

const prefix = 'reg_lkm_'

export const authStorageNameLkm = {
  firstName: `${prefix}first_name`,
  lastName: `${prefix}last_name`,
  middleName: `${prefix}middle_name`,
  email: `${prefix}email`,
  address: `${prefix}address`,
  productTypes: `${prefix}work_with`,
  serviceRegions: `${prefix}service_region`,
  documents: `${prefix}documents`,
  companyName: `${prefix}company_name`,
  personalAgree: `${prefix}personal_agree`,
  step: `${prefix}step`,
}

const parseServiceRegions = (value: string | null): TSuggest[] => {
  if (!value) return []

  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? (parsed as TSuggest[]) : []
  } catch (error) {
    console.error('Ошибка парсинга serviceRegions из sessionStorage:', error)
    return []
  }
}

const parseBoolean = (value: string | null): boolean => {
  if (!value) return false
  return value === 'true'
}

const parseDocuments = (value: string | null): RegistrationDocument[] => {
  if (!value) return []

  try {
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed)) return []

    return parsed
  } catch (error) {
    console.error('Ошибка парсинга documents из sessionStorage:', error)
    return []
  }
}

export const getRegistrationLkmFields = (): RegistrationLkmData => {
  const addressRaw = sessionStorage.getItem(authStorageNameLkm.address)
  const productTypesRaw = sessionStorage.getItem(
    authStorageNameLkm.productTypes,
  )

  const serviceRegionsRaw = sessionStorage.getItem(
    authStorageNameLkm.serviceRegions,
  )

  return {
    firstname: sessionStorage.getItem(authStorageNameLkm.firstName) || '',
    lastname: sessionStorage.getItem(authStorageNameLkm.lastName) || '',
    middlename: sessionStorage.getItem(authStorageNameLkm.middleName) || '',
    email: sessionStorage.getItem(authStorageNameLkm.email) || '',
    address: addressRaw?.length ? JSON.parse(addressRaw) : createEmptyAddress(),
    productTypes: productTypesRaw ? JSON.parse(productTypesRaw) : [],
    personalAgree: parseBoolean(
      sessionStorage.getItem(authStorageNameLkm.personalAgree),
    ),
    serviceRegions: parseServiceRegions(serviceRegionsRaw),
    companyName: sessionStorage.getItem(authStorageNameLkm.companyName) || '',
  }
}

export const getRegistrationLkmDocuments = (): RegistrationDocument[] => {
  const documentsRaw = sessionStorage.getItem(authStorageNameLkm.documents)
  return parseDocuments(documentsRaw)
}

export const setRegistrationLkmDocuments = (
  documents: RegistrationDocument[],
): void => {
  sessionStorage.setItem(
    authStorageNameLkm.documents,
    JSON.stringify(Array.isArray(documents) ? documents : []),
  )
}

export const getRegistrationLkmStep = (): number => {
  const stepRaw = sessionStorage.getItem(authStorageNameLkm.step)
  return stepRaw === '2' ? 2 : 1
}

export const deleteRegistrationLkmFields = () => {
  try {
    sessionStorage.removeItem(authStorageNameLkm.firstName)
    sessionStorage.removeItem(authStorageNameLkm.lastName)
    sessionStorage.removeItem(authStorageNameLkm.middleName)
    sessionStorage.removeItem(authStorageNameLkm.email)
    sessionStorage.removeItem(authStorageNameLkm.address)
    sessionStorage.removeItem(authStorageNameLkm.productTypes)
    sessionStorage.removeItem(authStorageNameLkm.serviceRegions)
    sessionStorage.removeItem(authStorageNameLkm.documents)
    sessionStorage.removeItem(authStorageNameLkm.companyName)
    sessionStorage.removeItem(authStorageNameLkm.personalAgree)
    sessionStorage.removeItem(authStorageNameLkm.step)
    sessionStorage.removeItem('inputSuggest')
  } catch (error) {
    console.error('Ошибка при удалении LKM элементов sessionStorage:', error)
  }
}

export const setRegistrationLkmFields = (
  watchFields: RegistrationLkmData,
  step?: number,
): void => {
  const {
    firstname,
    lastname,
    middlename,
    email,
    address,
    productTypes,
    serviceRegions,
    companyName,
    personalAgree,
  } = watchFields
  sessionStorage.setItem(authStorageNameLkm.firstName, firstname || '')
  sessionStorage.setItem(authStorageNameLkm.lastName, lastname || '')
  sessionStorage.setItem(authStorageNameLkm.middleName, middlename || '')
  sessionStorage.setItem(authStorageNameLkm.email, email || '')
  sessionStorage.setItem(
    authStorageNameLkm.productTypes,
    JSON.stringify(productTypes ?? []),
  )

  sessionStorage.setItem(
    authStorageNameLkm.serviceRegions,
    JSON.stringify(Array.isArray(serviceRegions) ? serviceRegions : []),
  )
  sessionStorage.setItem(authStorageNameLkm.companyName, companyName || '')
  sessionStorage.setItem(
    authStorageNameLkm.personalAgree,
    String(personalAgree || false),
  )

  if (address) {
    sessionStorage.setItem(authStorageNameLkm.address, JSON.stringify(address))
  } else {
    sessionStorage.removeItem(authStorageNameLkm.address)
  }

  if (step !== undefined) {
    sessionStorage.setItem(authStorageNameLkm.step, String(step))
  }
}

export const setEmptyRegistrationLkmFields = (): RegistrationLkmData => ({
  firstname: '',
  lastname: '',
  middlename: '',
  email: '',
  address: createEmptyAddress(),
  personalAgree: false,
  productTypes: [],
  serviceRegions: [],
  companyName: '',
})
